__turbopack_context__.v({
  "controlsWrapper": "tiWoNW_controlsWrapper",
  "dashContainer": "tiWoNW_dashContainer",
  "dateFieldContainer": "tiWoNW_dateFieldContainer",
  "dateLabel": "tiWoNW_dateLabel",
  "inputWrapper": "tiWoNW_inputWrapper",
  "legend": "tiWoNW_legend",
  "yearInput": "tiWoNW_yearInput",
});
